// extracted by mini-css-extract-plugin
export default {"implant":"ImplantPage_implant__CTloN"};